// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cadwnyiuwinrdodagjll.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNhZHdueWl1d2lucmRvZGFnamxsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE5NzUzOTQsImV4cCI6MjA2NzU1MTM5NH0.EvGa19JkWIC0P5xPGSoZxgeNbY8ElV766ZKI6QXw-ow";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});